import { InputStream } from './InputStream.js';
/**
 * ByteArrayInputStream
 *
 * @author Kazuhiko Arase
 */
export class ByteArrayInputStream extends InputStream {
    bytes;
    pos = 0;
    constructor(bytes) {
        super();
        this.bytes = bytes;
    }
    readByte() {
        if (this.pos < this.bytes.length) {
            const b = this.bytes[this.pos];
            this.pos += 1;
            return b;
        }
        return -1;
    }
}
//# sourceMappingURL=ByteArrayInputStream.js.map